var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBinRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0331,
    cy: 23.0318,
    r: 23,
    transform: "rotate(0.0792175 23.0331 23.0318)",
    fill: "#FDE0E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1670_28994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6704 17H32.3371",
    stroke: "#C4314B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8357 17.1666L16.0024 31.1666C16.0024 31.7855 16.2482 32.379 16.6858 32.8165C17.1234 33.2541 17.7169 33.5 18.3357 33.5H27.669C28.2879 33.5 28.8814 33.2541 29.3189 32.8165C29.7565 32.379 30.0024 31.7855 30.0024 31.1666L31.169 17.1666",
    stroke: "#C4314B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5024 16.8167V13.3167C19.5024 13.0073 19.6254 12.7105 19.8442 12.4917C20.0629 12.2729 20.3597 12.15 20.6691 12.15H25.3358C25.6452 12.15 25.9419 12.2729 26.1607 12.4917C26.3795 12.7105 26.5024 13.0073 26.5024 13.3167V16.8167",
    stroke: "#C4314B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6692 23L25.3359 27.6667M25.3359 23L20.6692 27.6667",
    stroke: "#C4314B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1670_28994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(9.00244 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBinRed);
export default __webpack_public_path__ + "static/media/Icon_Bin_Red.d6c23509b6fb64565fb357845e3ba261.svg";
export { ForwardRef as ReactComponent };